import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { policyType as PolicyTypes } from '@ourbranch/lookups';

import { NotificationCard } from 'core/components/notification-card';
import { isUnofferedAutoPlan } from 'core/helpers/auto-direct-bill';

// The mutuals don't sell Direct Bill monthly auto (#36200). A migrated policy that carries it anyway
// keeps its plan visible on the Billing tab, with this note asking staff to move it to an offered plan.
const UnofferedPlanNote = ({ policyType, paymentMethod, paymentType }) => {
  if (policyType !== PolicyTypes.Auto || !isUnofferedAutoPlan({ method: paymentMethod, type: paymentType })) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <NotificationCard type="warning" header="Direct Bill monthly is not an offered auto payment plan">
        This policy's payment plan must be changed. Choose Direct with 2 payments or One Time, or switch to an automated
        payment method to pay monthly.
      </NotificationCard>
    </Grid>
  );
};

UnofferedPlanNote.propTypes = {
  policyType: PropTypes.string,
  paymentMethod: PropTypes.string,
  paymentType: PropTypes.string
};

export default UnofferedPlanNote;
